"use strict";
var appn;
(function (appn) {
    var dashboards;
    (function (dashboards) {
        var views;
        (function (views) {
            var dashboard;
            (function (dashboard) {
                var settings;
                (function (settings) {
                    class InitArgs {
                        constructor() {
                            this.dashboardId = appn.emptyString;
                            this.dashboardKey = appn.emptyString;
                            this.dashboardName = appn.emptyString;
                            this.shareKeyBaseUrl = appn.emptyString;
                            this.regenerateShareKeyUrl = appn.emptyString;
                            this.generateNewShareKeyUrl = appn.emptyString;
                        }
                    }
                    let _initArgs;
                    function init(args) {
                        _initArgs = args;
                        appn.select.init({
                            selector: 'select#iconsToDisplay',
                            isIconSelect: true
                        });
                        addEvents();
                        appn.folderFilter.initLinkedFolders();
                        var $trashBtn = $('nav .navbar-nav-right button[value*="Trash"].btn-danger');
                        if ($trashBtn.length > 0)
                            appn.trash.addTrashMessage($trashBtn, '#Dashboard_Name', 'Dashboard_VersionNo', 'Dashboard_Status');
                    }
                    settings.init = init;
                    function addEvents() {
                        const $table = $('#share-keys-table');
                        $table.on('change', '.key-public-toggle', function () {
                            const $checkbox = $(this);
                            const isChecked = $checkbox.is(':checked');
                            $checkbox.closest('td').find('.key-public-hidden').val(isChecked ? 'true' : 'false');
                        });
                        $table.on('change', '.key-enabled-toggle', function () {
                            const $checkbox = $(this);
                            const isChecked = $checkbox.is(':checked');
                            $checkbox.closest('td').find('.key-enabled-hidden').val(isChecked ? 'true' : 'false');
                        });
                        $table.on('click', '.btn-copy-link', function () {
                            const $input = $(this).closest('.input-group').find('.key-value-display');
                            const link = `${_initArgs.shareKeyBaseUrl}/${$input.val()}`;
                            navigator.clipboard.writeText(link).then(() => {
                                appn.toast.notify(appn.toast.Type.info, T('Share link copied to clipboard'));
                            }, () => {
                                appn.toast.notify(appn.toast.Type.error, T('Failed to copy link'));
                            });
                        });
                        $table.on('click', '.btn-regenerate-key', function (event) {
                            event.preventDefault();
                            const $btn = $(this);
                            const $row = $btn.closest('tr');
                            const keyId = $row.data('key-id');
                            if (!keyId || keyId === appn.emptyGuid) {
                                appn.toast.notify(appn.toast.Type.error, T('Cannot regenerate a new key. Please save first.'));
                                return;
                            }
                            appn.dialog.confirm({
                                title: T('Regenerate Key'),
                                message: T('Are you sure you want to regenerate this key? The old share link will stop working immediately.'),
                                callback: (result) => {
                                    if (result) {
                                        $btn.prop('disabled', true).find('i').addClass('fa-spin');
                                        appn.ajax.post({
                                            url: _initArgs.regenerateShareKeyUrl,
                                            data: { id: keyId },
                                            done: function (response) {
                                                const data = typeof response === 'string' ? JSON.parse(response) : response;
                                                if (data.success) {
                                                    $row.find('.key-value-display').val(data.newKey);
                                                    $row.find('.key-value-hidden').val(data.newKey);
                                                    $row.find('.key-regenerated-flag').val('false');
                                                    $row.find('.btn-copy-link').prop('disabled', false);
                                                    appn.toast.notify(appn.toast.Type.info, T('Key regenerated successfully.'));
                                                }
                                                else {
                                                    appn.toast.notify(appn.toast.Type.error, T('Failed to regenerate key.'));
                                                }
                                            },
                                            fail: function () {
                                                appn.toast.notify(appn.toast.Type.error, T('An error occurred. Please try again.'));
                                            },
                                            always: function () {
                                                $btn.prop('disabled', false).find('i').removeClass('fa-spin');
                                            }
                                        });
                                    }
                                }
                            });
                        });
                        $table.on('click', '.btn-delete-key', function (event) {
                            event.preventDefault();
                            const $row = $(this).closest('tr');
                            appn.dialog.confirm({
                                title: T('Delete Key'),
                                message: T('Are you sure you want to permanently delete this share key? This change will only be saved when you click Save.'),
                                callback: (result) => {
                                    if (result) {
                                        $row.remove();
                                        renameShareKeyRows();
                                        if ($table.find('tbody tr').length === 0) {
                                            $table.find('tbody').append('<tr id="no-share-keys-row"><td colspan="5" class="text-center">' + T("No share keys have been created yet.") + '</td></tr>');
                                        }
                                    }
                                }
                            });
                        });
                        $('#btn-add-share-key').on('click', function (event) {
                            event.preventDefault();
                            const name = T('New Key');
                            const $btn = $('#btn-add-share-key');
                            $btn.prop('disabled', true).find('i').addClass('fa-spin');
                            appn.ajax.get({
                                url: _initArgs.generateNewShareKeyUrl,
                                done: function (response) {
                                    const data = typeof response === 'string' ? JSON.parse(response) : response;
                                    if (data.success) {
                                        const newKey = data.newKey;
                                        $('#no-share-keys-row').remove();
                                        const newIndex = $('#share-keys-table tbody tr').length;
                                        const newRowHtml = createNewShareKeyRow(name, newKey, newIndex);
                                        $('#share-keys-table tbody').append(newRowHtml);
                                        appn.toast.notify(appn.toast.Type.info, T('New key added. Click Save to apply changes.'));
                                    }
                                    else {
                                        appn.toast.notify(appn.toast.Type.error, data.message || T('Failed to generate new key.'));
                                    }
                                },
                                fail: function () {
                                    appn.toast.notify(appn.toast.Type.error, T('An error occurred. Please try again.'));
                                },
                                always: function () {
                                    $btn.prop('disabled', false).find('i').removeClass('fa-spin');
                                }
                            });
                        });
                        function createNewShareKeyRow(name, keyValue, newIndex) {
                            const prefix = `ShareKeys[${newIndex}]`;
                            const emptyGuid = '00000000-0000-0000-0000-000000000000';
                            const newKeyId = `new-key-${newIndex}`;
                            const newPublicId = `public-new-key-${newIndex}`;
                            const providerId = $('#Dashboard_ProviderId').val();
                            const dashboardKey = $('#Dashboard_DashboardKey').val();
                            return `
            <tr data-key-id="${emptyGuid}">
                <input type="hidden" class="key-id" name="${prefix}.Id" value="${emptyGuid}" />
                <input type="hidden" class="key-dashboard-key" name="${prefix}.DashboardKey" value="${dashboardKey}" />
                <input type="hidden" class="key-type" name="${prefix}.KeyType" value="Custom" />
                <input type="hidden" class="key-value-hidden" name="${prefix}.KeyValue" value="${keyValue}" />
                <td class="key-name">
                    <input type="text" class="form-control key-name-input" name="${prefix}.Name" value="${name}" />
                </td>
                <td>
                    ${T('Custom')}
                </td>
                <td>
                    <div class="input-group">
                        <input type="text" class="form-control key-value-display" value="${keyValue}" readonly />
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary btn-copy-link" type="button" title="${T('Copy Link')}"><i class="fa fa-copy"></i></button>
                        </div>
                    </div>
                </td>
                <td>
                    <input type="hidden" class="key-public-hidden" name="${prefix}.IsPublic" value="false" />
                    <div class="icheck-primary appn-checkbox d-inline">
                        <input type="checkbox" id="${newPublicId}" class="key-public-toggle" value="true" />
                        <label class="key-public-label" for="${newPublicId}"></label>
                    </div>
                </td>
                <td>
                    <input type="hidden" class="key-enabled-hidden" name="${prefix}.IsEnabled" value="true" />
                    <div class="icheck-primary appn-checkbox d-inline">
                        <input type="checkbox" id="enabled-${newKeyId}" class="key-enabled-toggle" value="true" checked />
                        <label class="key-enabled-label" for="enabled-${newKeyId}"></label>
                    </div>
                </td>
                <td>
                    <button type="button" class="btn btn-sm btn-outline-info btn-regenerate-key" title="${T('Save to enable regeneration')}" disabled><i class="fa fa-sync"></i></button>
                    <button type="button" class="btn btn-sm btn-outline-danger btn-delete-key" title="${T('Delete Key')}"><i class="fa fa-trash"></i></button>
                </td>
            </tr>
        `;
                        }
                        function renameShareKeyRows() {
                            $('#share-keys-table tbody tr').each(function (index, row) {
                                const $row = $(row);
                                const prefix = `ShareKeys[${index}]`;
                                if ($row.attr('id') === 'no-share-keys-row')
                                    return;
                                const newKeyId = `enabled-new-key-${index}`;
                                const newPublicId = `public-new-key-${index}`;
                                $row.find('.key-id').attr('name', `${prefix}.Id`);
                                $row.find('.key-dashboard-key').attr('name', `${prefix}.DashboardKey`);
                                $row.find('.key-type').attr('name', `${prefix}.KeyType`);
                                $row.find('.key-value-hidden').attr('name', `${prefix}.KeyValue`);
                                $row.find('.key-name-input').attr('name', `${prefix}.Name`);
                                $row.find('.key-value-hidden').attr('name', `${prefix}.KeyValue`);
                                $row.find('.key-name-input').attr('name', `${prefix}.Name`);
                                const $checkbox = $row.find('.key-enabled-toggle');
                                $row.find('.key-public-hidden').attr('name', `${prefix}.IsPublic`);
                                const $publicCheckbox = $row.find('.key-public-toggle');
                                if (newRowId && newRowId.startsWith('public-new-key-')) {
                                    $publicCheckbox.attr('id', newPublicId);
                                    $row.find('.key-public-label').attr('for', newPublicId);
                                }
                                $row.find('.key-enabled-hidden').attr('name', `${prefix}.IsEnabled`);
                                var newRowId = $checkbox.attr('id');
                                if (newRowId && newRowId.startsWith('enabled-new-key-')) {
                                    $checkbox.attr('id', newKeyId);
                                    $row.find('.key-enabled-label').attr('for', newKeyId);
                                }
                            });
                        }
                        $('#saveLink, .btn[name="submitType"]').click(function (event) {
                            event.preventDefault();
                            let submitType = 'Save';
                            const $form = $('form#appnForm');
                            if ($(this).hasClass('btn')) {
                                submitType = $(this).val();
                                if (submitType.trim().toLowerCase() === 'delete' || submitType.trim().toLowerCase() === 'deleteall')
                                    return;
                                $form.find('#submitTypeInput').remove();
                                $form.append($('<input id="submitTypeInput" type="hidden" name="submitType" />').val(submitType));
                            }
                            $form.submit();
                        });
                    }
                })(settings = dashboard.settings || (dashboard.settings = {}));
            })(dashboard = views.dashboard || (views.dashboard = {}));
        })(views = dashboards.views || (dashboards.views = {}));
    })(dashboards = appn.dashboards || (appn.dashboards = {}));
})(appn || (appn = {}));
